import { motion } from 'framer-motion';
import { Shield, Droplets, FileKey } from 'lucide-react';

const cards = [
  {
    icon: Shield,
    title: 'Strategic Resource',
    text: 'Positions iodine as a high-value industrial commodity supported by digital infrastructure and premium market branding for institutional-grade credibility.',
  },
  {
    icon: Droplets,
    title: 'High-Concentration Source',
    text: 'Built around iodine-rich water reserves with concentrations reaching 180 mg/L, forming the backbone of a differentiated and defensible supply narrative.',
  },
  {
    icon: FileKey,
    title: 'Patent-Linked Technology',
    text: 'Connected to proprietary extraction methodologies and intellectual property positioning designed for future industrial scalability and licensing.',
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } }
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } }
};

const headerMotion = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-100px' },
  transition: { duration: 0.6 },
};

const gridViewport = { once: true, margin: '-80px' };

function OverviewCard({ card, index }) {
  return (
    <motion.div
      key={card.title}
      variants={cardVariants}
      data-testid={`overview-card-${index}`}
      className="card-glow group rounded-sm border border-[rgba(59,130,246,0.12)] bg-[#0A1628] p-8 transition-all duration-400 hover:-translate-y-1 hover:shadow-xl hover:shadow-blue-900/10"
    >
      <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-sm bg-[rgba(59,130,246,0.08)] border border-[rgba(59,130,246,0.2)]">
        <card.icon className="w-5 h-5 text-[#3B82F6]" strokeWidth={1.5} />
      </div>
      <h3 className="text-xl font-bold text-[#F1F5F9]">{card.title}</h3>
      <p className="mt-3 leading-relaxed text-[#94A3B8]">{card.text}</p>
    </motion.div>
  );
}

export default function OverviewSection() {
  return (
    <section id="overview" data-testid="overview-section" className="py-24 lg:py-32" style={{ background: '#060B1E' }}>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div {...headerMotion} className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#3B82F6]">Overview</div>
          <h2 className="mt-4 text-3xl sm:text-4xl font-bold tracking-tight text-[#F1F5F9]">
            A premium platform for iodine resource positioning.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-[#94A3B8]">
            IODX delivers a professional-facing identity that communicates industrial relevance, resource strength, and modern capital-market readiness.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={gridViewport}
          className="mt-16 grid gap-6 md:grid-cols-3"
        >
          {cards.map((card, i) => (
            <OverviewCard key={card.title} card={card} index={i} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
